import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { shouldNoindexPath } from '@/lib/seo';

/** Layout dışında kalan sayfalar dahil, özel/oturumluk rotalara noindex basar. */
export function RouteSeo() {
  const { pathname } = useLocation();
  if (!shouldNoindexPath(pathname)) return null;
  return (
    <Helmet>
      <meta name="robots" content="noindex,follow" />
    </Helmet>
  );
}
